<template>
  <v-layout column align-center>
    <v-flex class="logout-loading">
      <v-progress-circular size="200" indeterminate color="primary" />
    </v-flex>
  </v-layout>
</template>

<script>
import { keycloakService } from '@/services/keycloak-service'

export default {
  created() {
    keycloakService.logout()
  }
}
</script>

<style scoped>
.logout-loading {
  padding-top: 100px;
}
</style>
